/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type NextGenRoadmapType from '@jira/spa-apps__roadmap/src/NextGenExportedDefault.tsx';
import type { EntryPointProps } from 'react-relay';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyNextGenRoadmap: LazyComponent<
	React.NamedExoticComponent<EntryPointProps<{}, {}, {}, {}>>
> = lazyForPaint<typeof NextGenRoadmapType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-roadmap", jiraSpaEntry: "async-roadmap" */ '@jira/spa-apps__roadmap/src/NextGenExportedDefault.tsx'
		),
	),
);

const AsyncNextGenRoadmap = ({ match }: RouteContext): React.JSX.Element => (
	<LazyPage
		Page={LazyNextGenRoadmap}
		pageId={`next-gen-roadmap-${match.params.boardId || ''}`}
		shouldShowSpinner={false}
	/>
);

export default AsyncNextGenRoadmap;
